import * as moment from "moment";
import { ISettingsService } from "../typings/typings";

export const toUserTime = [
    "SettingsService",
    (SettingsService: ISettingsService) => {
        return function(eslDate, formatString) {
            formatString = formatString ? formatString : "DD/MMM/YYYY HH:mm";
            let localDate = moment.tz(eslDate, SettingsService.user.timezone.name);
            return localDate.format(formatString);
        };
    },
];

export const removeLegacyPrefix = [
    "LegacyUrlService",
    LegacyUrlService => {
        return function(uri) {
            return LegacyUrlService.getPathFromLegacyPath(uri);
        };
    },
];
